import React from 'react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { heroData } from '../data/mock';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const scrollToServices = () => {
    const element = document.querySelector('#services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const highlights = [
  "Enterprise IT Solutions", "IT Automation",

  "Industry Expertise"];


  return (
    <section id="home" className="relative min-h-screen flex items-center pt-20 overflow-hidden">
      {/* Background with overlay */}
      <div className="absolute inset-0 z-0">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${heroData.backgroundImage})` }}>
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/95 via-gray-900/90 to-cyan-900/80"></div>
        {/* Animated dots pattern */}
        <div className="absolute inset-0 opacity-10" style={{
          backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-white">
            <div className="inline-block px-4 py-2 bg-cyan-500/20 backdrop-blur-sm rounded-full border border-cyan-400/30 mb-6">
              <span className="text-cyan-300 font-semibold text-sm">
                {heroData.subtitle}
              </span>
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6">
              {heroData.title}
            </h1>
            
            <p className="text-lg md:text-xl text-gray-300 mb-8 leading-relaxed">
              {heroData.description}
            </p>

            {/* Highlights */}
            <div className="flex flex-wrap gap-4 mb-10">
              {highlights.map((highlight, index) =>
              <div key={index} className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg border border-white/20">
                  <CheckCircle2 className="text-lime-400" size={20} />
                  <span className="text-white font-medium">{highlight}</span>
                </div>
              )}
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={scrollToContact}
                className="group px-8 py-4 bg-gradient-to-r from-cyan-500 to-lime-500 text-white font-bold rounded-lg shadow-2xl hover:shadow-cyan-500/50 transform hover:scale-110 transition-all duration-300 flex items-center justify-center space-x-2 relative overflow-hidden"
              >
                <span className="relative z-10">Contact Us</span>
                <ArrowRight className="relative z-10 group-hover:translate-x-1 transition-transform" size={20} />
                <span className="absolute inset-0 bg-gradient-to-r from-lime-500 to-cyan-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
              </button>
              <button
                onClick={scrollToServices}
                className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-bold rounded-lg border-2 border-white/30 hover:bg-white/20 hover:border-white/50 hover:shadow-lg hover:shadow-white/20 transform hover:scale-105 transition-all duration-300"
              >
                Explore Solutions
              </button>
            </div>
          </div>

          {/* Right Content - Stats Cards */}
          <div className="hidden lg:grid grid-cols-2 gap-6">
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 hover:bg-white/15 transition-all duration-300 transform hover:-translate-y-2">
              <div className="text-5xl font-bold text-lime-400 mb-2">100+</div>
              <div className="text-white font-semibold mb-1">Solutions Delivered</div>
              <div className="text-gray-300 text-sm">Across multiple industries</div>
            </div>
            
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 hover:bg-white/15 transition-all duration-300 transform hover:-translate-y-2 mt-8">
              <div className="text-5xl font-bold text-cyan-400 mb-2">15+</div>
              <div className="text-white font-semibold mb-1">Service Categories</div>
              <div className="text-gray-300 text-sm">Comprehensive IT solutions</div>
            </div>
            
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 hover:bg-white/15 transition-all duration-300 transform hover:-translate-y-2">
              <div className="text-5xl font-bold text-lime-400 mb-2">24/7</div>
              <div className="text-white font-semibold mb-1">Support Available</div>
              <div className="text-gray-300 text-sm">Round-the-clock assistance</div>
            </div>
            
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 hover:bg-white/15 transition-all duration-300 transform hover:-translate-y-2 mt-8">
              <div className="text-5xl font-bold text-cyan-400 mb-2">100%</div>
              <div className="text-white font-semibold mb-1">Client Satisfaction</div>
              <div className="text-gray-300 text-sm">Our vision and commitment</div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent z-10"></div>
    </section>);

};

export default Hero;